//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Utils imports
import { QUERY_KEYS } from "@/utils/query-client";

//* Types imports
import type { IProduct } from "@/features/Element/types";

async function indexProducts(): Promise<IProduct[]> {
  const response = await fetch(`${API_URL}/products`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }

  return response.json();
}

export function useIndexProducts() {
  return useQuery<IProduct[]>({
    queryKey: [QUERY_KEYS.PRODUCTS.ALL],
    queryFn: indexProducts,
  });
}
